import ConnectedResourceNotFoundPage from './ResourceNotFoundPage';

export default ConnectedResourceNotFoundPage;
